import { render } from "./SwayTestsByDomain.vue?vue&type=template&id=52e8ec52&scoped=true"
import script from "./SwayTestsByDomain.vue?vue&type=script&lang=js"
export * from "./SwayTestsByDomain.vue?vue&type=script&lang=js"

import "./SwayTestsByDomain.vue?vue&type=style&index=0&id=52e8ec52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e8ec52"]])

export default __exports__